import { Box } from "@mui/material";
import { TimezoneMenu } from "components/layout/menus/TimezoneMenu";
import { T } from "components/util/t";
import dayjs from "dayjs";
import { Event } from "graphql/generated/types";
import { useState } from "react";
import { LONG_DATE_WITHOUT_YEAR, timeFormat } from "utils/dates";

type RegistrationDescriptionProps = Pick<
    Event,
    "scheduledEntryOpen" | "scheduledEntryClose" | "location"
>;

type RegistrationDescriptionDatesProps = RegistrationDescriptionProps & {
    timezoneOffset: number;
};

export const RegistrationDescription: React.FC<
    RegistrationDescriptionProps
> = ({ scheduledEntryOpen, scheduledEntryClose, location }) => {
    const eventOffsetMinutes = location?.timezone?.utcOffsetMinutes;
    const [selectedTimezone, setSelectedTimezone] = useState(
        eventOffsetMinutes || dayjs().utcOffset(),
    );

    return (
        <>
            <Box
                component={"section"}
                gap={0.5}
                display="inline-flex"
                alignItems={"center"}
            >
                <RegistrationDescriptionDates
                    scheduledEntryOpen={scheduledEntryOpen}
                    scheduledEntryClose={scheduledEntryClose}
                    timezoneOffset={selectedTimezone}
                />
                {eventOffsetMinutes && (
                    <TimezoneMenu
                        eventUtcOffsetMinutes={eventOffsetMinutes}
                        onChange={setSelectedTimezone}
                    />
                )}
            </Box>
            {". "}
        </>
    );
};

export const RegistrationDescriptionDates: React.FC<
    RegistrationDescriptionDatesProps
> = ({ scheduledEntryOpen, scheduledEntryClose, timezoneOffset }) => {
    if (!scheduledEntryOpen && !scheduledEntryClose) {
        return null;
    }

    if (scheduledEntryOpen && !scheduledEntryClose) {
        const open = dayjs(scheduledEntryOpen).utcOffset(timezoneOffset);

        return (
            <T
                openDate={open.format(LONG_DATE_WITHOUT_YEAR)}
                openTime={open.format(timeFormat())}
            >
                registration_open_at
            </T>
        );
    }

    if (!scheduledEntryOpen && scheduledEntryClose) {
        const close = dayjs(scheduledEntryClose).utcOffset(timezoneOffset);

        return (
            <T
                closeDate={close.format(LONG_DATE_WITHOUT_YEAR)}
                closeTime={close.format(timeFormat())}
            >
                registration_close_at
            </T>
        );
    }

    const open = dayjs(scheduledEntryOpen).utcOffset(timezoneOffset);
    const close = dayjs(scheduledEntryClose).utcOffset(timezoneOffset);

    return (
        <T
            openDate={open.format(LONG_DATE_WITHOUT_YEAR)}
            openTime={open.format(timeFormat())}
            closeDate={close.format(LONG_DATE_WITHOUT_YEAR)}
            closeTime={close.format(timeFormat())}
        >
            registration_between
        </T>
    );
};
